import { Button, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';

const styles = {
  contentContainer: {
    backgroundColor: '#fff',
    borderRadius: 4,
    width: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    '@media (max-height: 750px)': {
      maxHeight: 600,
      overflowY: 'auto'
    }
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center'
  },
  body: {
    padding: '40px 30px'
  },
  marginTop32: {
    marginTop: 32
  },
  buttonConfirm: {
    width: '100%',
    fontSize: 14,
    fontWeight: 700
  },
  menuName: {
    fontSize: 16,
    fontWeight: 400,
    marginBottom: 5
  },
  p0: {
    padding: 0
  },
  amountBox: {
    margin: '8px 0 24px'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    handleCloseUpdateAmountSuccessModal,
    amountUpdated,
    gochiChoseUpdateAmount,
    oldAmountUpdateAmount
  }) => {
    return (
      <>
        <div className={classes.contentContainer}>
          <div className={classes.body}>
            <Typography className={classes.title} variant="h6">
              金額修正 完了
            </Typography>
            <Typography className={classes.menuName}>
              <span>コース名：</span>
              <span>{gochiChoseUpdateAmount.menuName}</span>
              <span>の修正を完了しました。</span>
            </Typography>

            <div className={classes.amountBox}>
              <Typography className={classes.p0}>
                <span>修正前：</span>
                <span>
                  {oldAmountUpdateAmount
                    ? Number(oldAmountUpdateAmount).toLocaleString()
                    : 0}
                </span>
                <span>円</span>
              </Typography>
              <Typography className={classes.p0}>
                <span>修正後：</span>
                <span>
                  {amountUpdated ? Number(amountUpdated).toLocaleString() : 0}
                </span>
                <span>円</span>
              </Typography>
            </div>

            <div className={classes.marginTop32}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  handleCloseUpdateAmountSuccessModal();
                }}
                className={classes.buttonConfirm}
              >
                閉じる
              </Button>
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
